export const readSavedLocale = (enabled, version) => {
  try {
    const consent = JSON.parse(localStorage.getItem('maldhowr_consent'));
    if (!enabled || (consent?.optional && consent.version === version)) return localStorage.getItem('maldhowr_locale');
  } catch { console.warn('Language preference could not be read; using the default language.'); }
  return null;
};

export const saveLocale = (value, enabled, version) => {
  try {
    const consent = JSON.parse(localStorage.getItem('maldhowr_consent'));
    if (!enabled || (consent?.optional && consent.version === version)) localStorage.setItem('maldhowr_locale', value);
  } catch { console.warn('Language preference could not be saved; the selection applies to this page only.'); }
};